import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-download-progress',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './download-progress.component.html',
  styleUrls: ['./download-progress.component.scss']
})
export class DownloadProgressComponent {
  @Input() downloadProgress: number = 0;
}
